require('./e3-button-tooltip.scss');

import E3Tooltip from '../e3-tooltip/e3-tooltip';

class E3ButtonTooltip extends E3Tooltip {
    constructor(TranslationService, options = {}) {
        super(options);
        this._translationPromise = TranslationService.getTranslation();
        this._translate = TranslationService.translate.bind(TranslationService);
    }

    _init() {
        let title = document.createElement('p');
        this._tooltip.element = document.createElement('div');

        this._tooltip.element.classList.add('e3-button-tooltip');
        this._tooltip.element.appendChild(title);

        this._tooltip.title = title;
    }

    _bindEvents(name) {
        let element = this._elements[name].element;
        let mouseenter = this._onMouseEnter.bind(this, name);
        let mouseleave = this._onMouseLeave.bind(this, name);

        this._elements[name].mouseenter = mouseenter;
        this._elements[name].mouseleave = mouseleave;

        element.addEventListener('mouseenter', mouseenter);
        element.addEventListener('mouseleave', mouseleave);
    }

    _unbindEvents(name) {
        let element = this._elements[name].element;
        let mouseenter = this._elements[name].mouseenter;
        let mouseleave = this._elements[name].mouseleave;

        element.removeEventListener('mouseenter', mouseenter);
        element.removeEventListener('mouseleave', mouseleave);
    }

    _onMouseEnter(name, e) {
        if(!this._elements[name] || this._elements[name].element.contains(this._elements[name].element.querySelector('.speech-bubble'))) return ;

        let element = this._elements[name].element;
        let {title, align} = this._elements[name];

        if (window.e3touchDevice || !element) return;

        this._tooltip.title.innerText = title;
        this._tooltip.element.classList.add(align);

        element.appendChild(this._tooltip.element);

    }

    _onMouseLeave(name, e) {
        let element = this._elements[name].element;
        let {align} = this._elements[name];

        if (!element || !element.contains(this._tooltip.element)) return;

        try {
            element.removeChild(this._tooltip.element);
        } catch (e) {
            console.error(e);

            return;
        }

        this._tooltip.element.classList.remove(align);
        this._tooltip.title.innerText = '';
    }

    // `fallback` covers keys that are not in the remote vocabulary yet —
    // translate() hands back the key itself in that case.
    add(name, element, title, align = 'center', fallback = '') {
        this._elements[name] = this._translationPromise
            .then(() => {
                const key = title;
                title = this._translate(title);
                if (fallback && (!title || title === key)) title = fallback;
                this._elements[name] = {element, title, align};
                this._bindEvents(name);
            })
    }

    remove(name) {
        if (this._elements[name] && this._elements[name].then) {
            this._elements[name].then(() => {
                this._unbindEvents(name);

                delete this._elements[name];
            });

            return;
        }

        this._unbindEvents(name);

        delete this._elements[name];
    }

    destroy() {
        Object.keys(this._elements).forEach((key) => this.remove(key));
    }
}

export default E3ButtonTooltip
